import { Route, Switch } from "react-router-dom";
import ListagemPage from "./Listagem";
import DetalhesPage from "./Detalhes";

function CrmCobrancaPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/receita/cobranca"
        component={ListagemPage}
      />
      <Route
        exact
        path="/financeiro/receita/cobranca/:id"
        component={DetalhesPage}
      />
    </Switch>
  );
}

export default CrmCobrancaPages;
